import { Button, ButtonProps, Link as MuiLink } from '@mui/material';
import { useField } from 'formik';

import { EPosSystem, POS_INSTRUCTIONS } from '@/config/station';

type TPassProps = Pick<ButtonProps, 'size' | 'sx' | 'fullWidth' | 'startIcon' | 'children'>;

type TPosInstructionsProps = TPassProps & {
  name: string;
};

export const PosInstructions = ({ name, ...props }: TPosInstructionsProps) => {
  const [field] = useField<EPosSystem>(`${name}.system`);
  const { url, fileName } = POS_INSTRUCTIONS[field.value];

  return <Button target="_blank" {...props} component={MuiLink} download={fileName} href={url} />;
};
